import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactDataGrid from 'react-data-grid';

import GenericButton from './GenericButton';
import GenericSearch from './GenericSearch';
import BrowseSharedRowRender from './BrowseSharedRowRender';

import { upperCaseIfString } from '../../util/CommonUtils';

import * as definitionActions from '../../actions/definitionActions';

const columns = [
  {
    key: 'Adopted',
    name: 'Adopted',
    sortable: true,
    width: 100,
    initialSort: 'DESC',
  },
  { key: 'Definition', name: 'Definition', sortable: true },
  { key: 'Creator', name: 'Creator', sortable: true },
  { key: 'Study', name: 'Study', sortable: true },
];

class BrowseShared extends Component {
  constructor(props) {
    super(props);
    this.state = { browseSharedList: [], checkedState: [] };
  }

  UNSAFE_componentWillMount() {
    this.props.definitionActions.getSharedList(this.props.accountId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.sharedList !== this.props.sharedList) {
      this.rows = nextProps.sharedList.data.map(
        ({
          adopted,
          definitionId,
          definitionName,
          ownerFName,
          ownerLName,
          surveyDesc,
        }) => {
          const row = {
            definitionId,
            Adopted: this.renderCheckbox(adopted),
            Checked: adopted,
            Definition: definitionName,
            Creator: `${ownerFName} ${ownerLName}`,
            Study: surveyDesc,
            isSelected: adopted === 'Y',
          };

          return row;
        },
      );
      this.setState({ browseSharedList: [...this.rows] });
    }
  }

  onCheckboxDeselected = rows => {
    this.renderCheckboxChanges(rows.row.definitionId, 'N');
    this.setCheckedState(rows.row.definitionId, 'N');
  };

  onCheckboxSelected = rows => {
    this.setCheckedState(rows.row.definitionId, 'Y');
    this.renderCheckboxChanges(rows.row.definitionId, 'Y');
  };

  setCheckedState = (definitionId, adopted) => {
    if (this.state.checkedState.length) {
      const newCheckedState = this.state.checkedState.reduce(
        (accumulator, currentValue) => {
          if (currentValue.definitionId !== definitionId) {
            accumulator.push(currentValue);
          }
          return accumulator;
        },
        [],
      );
      if (newCheckedState.length === this.state.checkedState.length) {
        newCheckedState.push({ definitionId, adopted });
      }
      this.setState({ checkedState: newCheckedState });
    } else {
      this.state.checkedState.push({ definitionId, adopted });
    }
  };

  handlefilteredList = result =>
    this.setState({ browseSharedList: [...result] });

  handleGridSort = (column, sortDirection) => {
    const sortColumn = column === 'Adopted' ? 'isSelected' : column;
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return upperCaseIfString(a[sortColumn]) >
          upperCaseIfString(b[sortColumn])
          ? 1
          : -1;
      }

      return upperCaseIfString(a[sortColumn]) < upperCaseIfString(b[sortColumn])
        ? 1
        : -1;
    };

    const browseSharedList = this.state.browseSharedList.sort(comparer);
    this.setState({ browseSharedList });
  };

  handleRowMouseDown = row => {
    if (row.row.Checked === 'N') {
      this.onCheckboxSelected(row);
    } else {
      this.onCheckboxDeselected(row);
    }
    return null;
  };

  handleSharedListRequest = () => {
    const BulkSharedFolder = this.state.checkedState.reduce(
      (accumulator, { adopted, definitionId }) => {
        if (adopted === 'N') {
          accumulator.abandon.push(definitionId);
        } else {
          accumulator.adopt.push(definitionId);
        }
        return accumulator;
      },
      { abandon: [], adopt: [] },
    );
    if (BulkSharedFolder.abandon.length || BulkSharedFolder.adopt.length) {
      this.props.definitionActions.adoptSharedFolder(
        this.props.token,
        this.props.uid,
        this.props.accountId,
        this.props.productNo,
        this.props.studySource,
        BulkSharedFolder,
      );
    }
  };

  rowGetter = i => this.state.browseSharedList[i];

  renderCheckbox = adopted => (
    <input type="checkbox" checked={adopted === 'Y'} onChange={() => {}} />
  );

  renderCheckboxChanges = (definitionId, adopted) => {
    const newSharedlist = this.state.browseSharedList.reduce(
      (accumulator, folder) => {
        if (folder.definitionId === definitionId) {
          accumulator.push({
            ...folder,
            Adopted: this.renderCheckbox(adopted),
            Checked: adopted,
            isSelected: adopted === 'Y',
          });
        } else {
          accumulator.push(folder);
        }
        return accumulator;
      },
      [],
    );
    this.setState({ browseSharedList: newSharedlist });
  };

  render() {
    return (
      <div>
        <GenericSearch
          searchItems={this.rows}
          searchField="Definition"
          handleSearchResult={this.handlefilteredList}
        />
        <ReactDataGrid
          rowKey="id"
          columns={columns}
          rowGetter={this.rowGetter}
          rowsCount={this.state.browseSharedList.length}
          rowRenderer={
            <BrowseSharedRowRender
              handleRowMouseDown={this.handleRowMouseDown}
            />
          }
          minHeight={300}
          headerRowHeight={50}
          onGridSort={this.handleGridSort}
          rowSelection={{
            showCheckbox: false,
            selectBy: { isSelectedKey: 'isSelected' },
          }}
        />
        <div className="button-group text-right margin-top-15">
          <GenericButton
            name="OK"
            btnStyle="button"
            onBtnClick={() => {
              this.handleSharedListRequest();
              this.props.handleHide();
            }}
          />
          <GenericButton
            name="Cancel"
            btnStyle="button btn-cncl"
            onBtnClick={() => this.props.handleHide()}
          />
        </div>
      </div>
    );
  }
}

BrowseShared.propTypes = {
  handleHide: PropTypes.func,
  sharedList: PropTypes.shape({}),
  definitionActions: PropTypes.shape({
    adoptSharedFolder: PropTypes.func,
    getSharedList: PropTypes.func,
  }),
  token: PropTypes.string,
  uid: PropTypes.number,
  accountId: PropTypes.number,
  productNo: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    sharedList: state.definition.sharedList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    definitionActions: bindActionCreators(definitionActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrowseShared);
